import classNames from 'classnames';
import styles from '../styles/timer.module.scss';

export default function VerticalTimer(props: {
  remainingTime: number;
  duration: number;
  isPlaying: boolean;
}) {
  return (
    <div className={styles.vertical}>
      {props.isPlaying && props.remainingTime}
      <div
        className={classNames(styles.container, props.isPlaying && props.remainingTime < 1 && styles.warning)}
      >
        {props.isPlaying && (
          <div
            className={styles.inner}
            style={{
              top: `${100 - (props.remainingTime / props.duration) * 100}%`,
            }}
          />
        )}
      </div>
    </div>
  );
}
